const intFmt = new Intl.NumberFormat('en-US');

/** 1142 -> "1,142". Tabular numerals are the stylesheet's job. */
export function count(n: number): string {
  return intFmt.format(n);
}

/** "1 chapter" / "3 chapters". */
export function plural(n: number, one: string, many = `${one}s`): string {
  return `${count(n)} ${n === 1 ? one : many}`;
}

/**
 * Time spent reading as figure-and-unit pairs, so the unit can be set smaller:
 * "42 min", "3 h 5 min", "3 h". Whole minutes; past 100 hours the minutes go.
 */
export function readingTime(seconds: number): [figure: string, unit: string][] {
  const minutes = Math.floor(Math.max(0, seconds) / 60);
  if (minutes < 60) return [[count(minutes), 'min']];
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 || h >= 100
    ? [[count(h), 'h']]
    : [
        [count(h), 'h'],
        [count(m), 'min'],
      ];
}

/** Offsets as the citation source line prints them: "12,884–13,061". */
export function offsetRange(start: number, end: number): string {
  return `${count(start)}–${count(end)}`;
}

/** Relative day for next-due copy: "today", "tomorrow", "in 6 days", "in 3 weeks". */
export function relativeDay(iso: string, now = new Date()): string {
  const days = Math.round((new Date(iso).getTime() - now.getTime()) / 86_400_000);
  if (days <= 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days < 14) return `in ${days} days`;
  if (days < 60) return `in ${Math.round(days / 7)} weeks`;
  return `in ${Math.round(days / 30)} months`;
}
